import { TesteSociocomportamental } from '../../types/teste-sociocomportamental.types';

export const TESTE_SOCIOCOMPORTAMENTAL: TesteSociocomportamental = {
  urlVideoApresentacao: 'https://play.yduqs.videolib.live/player?token=c994bc011a5845b08bf2dea0919c6c4f',
  ativo: true,
};
